import { useQuery } from "@tanstack/react-query";
import { bulkImportApi } from "./axios"; // crea esta instancia: baseURL `api/stk-bulk-import`
import {
  ServiceResponseI,
  DataI,
  ListBulkImportForFrontI,
  BulkImportResultI,
  PropsBulkImportI,
} from "../../interfaces";
import { ValidateCurrentToken, LogoutSystem } from "../../helpers";
import { AxiosError } from "axios";

// Sube el archivo (multipart). NO seteamos Content-Type: el browser
// pone el boundary correcto al pasar un FormData.
export const importBulk = async (
  file: File,
  importTypeCode: string,
): Promise<ServiceResponseI<BulkImportResultI>> => {
  const t = ValidateCurrentToken();
  if (!t) throw new Error("TOKEN INVALIDO");

  const fd = new FormData();
  fd.append("file", file);
  fd.append("importTypeCode", importTypeCode);

  const { data } = await bulkImportApi.post<
    ServiceResponseI<BulkImportResultI>
  >("/import", fd, {
    headers: { Authorization: t },
    timeout: 180_000, // hasta 3 min por si el archivo es grande
  });
  return data;
};

const getBulkImports = async ({
  pagination,
  sorting,
  globalFilter,
}: PropsBulkImportI): Promise<
  ServiceResponseI<DataI<ListBulkImportForFrontI>>
> => {
  try {
    const t = ValidateCurrentToken();
    if (!t) throw new Error("TOKEN INVALIDO");

    const params = new URLSearchParams();
    params.append("page", (pagination!.pageIndex + 1).toString());
    params.append("limit", pagination!.pageSize.toString());
    params.append("search", globalFilter ?? "");
    params.append("sorting", JSON.stringify(sorting ?? []));

    const { data } = await bulkImportApi.get<
      ServiceResponseI<DataI<ListBulkImportForFrontI>>
    >("", { params, headers: { Authorization: t } });
    return data;
  } catch (err) {
    const obj = (err as AxiosError).response;
    if (obj?.status === 401) LogoutSystem();
    throw new Error((obj?.data as Error).message);
  }
};

export const useBulkImports = ({
  pagination,
  sorting,
  globalFilter,
}: PropsBulkImportI) => {
  const bulkImportsQuery = useQuery(
    ["bulk-imports", { pagination, sorting, globalFilter }],
    () => getBulkImports({ pagination, sorting, globalFilter }),
    { refetchOnWindowFocus: false, keepPreviousData: true },
  );
  return { bulkImportsQuery };
};